module.exports = __webpack_public_path__ + "img/atencion.24ae77ae.png";